// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"456":"28cf8d5d5e5a293d","1778":"e93ff69c61beab12","2040":"4d67a8ee46d476f0","9539":"cd7e5f550865173b"}[chunkId] + ".css";
};